import { Col } from '@opendoor/atoms/box';
import type { EntryComponent } from 'cms/entries/entries';
import { Desc, TitleWithAccent } from 'components/landing-pages-v2/shared/Typography';
import type { ILpComponentLwcTextSection } from 'declarations/contentful';

import Grid from './Grid';

const RenderLWCTextSection = (entry: ILpComponentLwcTextSection) => {
  const { fields } = entry;
  const analyticsName = `cosmos-landing-page-lwc-text-section-${fields?.analyticsId}`;

  return (
    <Col analyticsName={analyticsName} trackImpression>
      <Grid>
        <Col className="col-span-12 mt-25 mb-16 w-full gap-5 md:mt-20 md:mb-20 md:gap-8 xl:flex-row xl:items-center xl:justify-between">
          <Col className="w-full gap-2">
            <TitleWithAccent title={fields?.title} maxWidth="unset" />
            <Desc $largerThanMD={{ fontSize: 24 }}>{fields?.description}</Desc>
          </Col>
        </Col>
      </Grid>
    </Col>
  );
};

const LWCTextSection: EntryComponent<ILpComponentLwcTextSection> = {
  render: RenderLWCTextSection,
};

export default LWCTextSection;
